const initialState = {basicDetails: [],labels: {},getSessionStorage:{},country:{}}
export default (state = initialState, action) => {
    switch (action.type) {
     case 'BASIC_DETAILS':
      return {
        ...state,
        basicDetails: action.payload
      }
      case 'LABEL_DETAILS':
        return {
          ...state,
          labels: action.payload
        }
        case 'COUNTRY':
          return {
            ...state,
            country: action.payload
          }
      case 'SESSION_STORAGE':
          return {
            ...state,
            getSessionStorage: action.payload
        }
        case 'CONNCETD_RESPONSE':
          return {
            ...state,
            getConnectedResponse: action.payload
        }
        case 'PARTIALSUCCESS':
          return {
            ...state,
            getPartialSuccess: action.payload
        }
     default:
      return state
    }
}

   